import type * as React from 'react';
import { JobInterviewEmployeeResponse } from '@doda/api-client/aspida/@types';
import { SectionItem } from '../SectionItem';
import { Interview } from './interview';
import { SectionItemPosition } from '../../CheckMarkBalloon/SectionItemPosition';
import styles from './index.module.scss';

/**
 * 社員インタビューのProps
 */
interface Props {
  employeeInterviews: JobInterviewEmployeeResponse[];
}

/** 社員インタビュー */
export const EmployeeInterview = ({ employeeInterviews }: Props) => {
  return (
    <>
      <SectionItemPosition />
      <SectionItem label="社員インタビュー">
        <div className={styles['jobSearchDetail-employeeInterviews']}>
          {employeeInterviews.map((interview) => (
            <Interview
              key={`${interview.index}${interview.text}`}
              name={interview.name || ''}
              relationship={interview.relationship || ''}
              entity={interview.entity || ''}
              text={interview.text || ''}
              imagePath={interview.imagePath || ''}
            />
          ))}
        </div>
      </SectionItem>
    </>
  );
};
